import React from 'react';
import connect from 'app/api/redux-util/connect-enhancer';
import BrandedFavicon from '../config/BrandedFavicon';
import Pages from './Pages';
import CenteredLoader from '../core/common/CenteredLoader';
import { SYSTEM_ERROR } from '../../api/redux-route/routes';
import RedirectOnce from 'app/ui/route/RedirectOnce';
import CSSFeatures from '../core/common/CSSFeatures';
import ClickTracker from '../analytics/ClickTracker';
import AnalyticsInit from '../analytics/AnalyticsInit';
import HistoryTracker from '../analytics/HistoryTracker';
import './style/Main.css';
import {
  initAppData,
  getAppInitStatus,
  ERROR,
  LOADING,
} from '../../api/redux-watson/app-init';
import ThemedFocus from 'app/ui/config/ThemedFocus';
import { isDevOrLocal } from '../../utils/env';
import DevTools from './DevTools';
import DocLang from '../config/DocLang';
import ReporterContext from 'app/ui/analytics/ReporterContext';

class Main extends React.Component {
  componentDidMount() {
    this.props.initAppData();
  }

  render() {
    if (this.props.status === LOADING) {
      return (
        // We are not using MainSizer in order to not pull in all the stuff
        // associated with that import during the initial load
        // (e.g react-modal)
        <div className="Main">
          <CenteredLoader fullScreen />
        </div>
      );
    }

    return (
      <CSSFeatures>
        <ThemedFocus>
          <BrandedFavicon />
          <Pages />
        </ThemedFocus>
        <AnalyticsInit />
        <ReporterContext />
        <ClickTracker />
        <HistoryTracker />
        <DocLang />
        {isDevOrLocal() && <DevTools />}
        {this.props.status === ERROR && <RedirectOnce to={SYSTEM_ERROR} />}
      </CSSFeatures>
    );
  }
}

const mapStateToProps = state => {
  return {
    status: getAppInitStatus(state),
  };
};

const mapDispatchToProps = {
  initAppData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);

export const MainTest = Main;



// WEBPACK FOOTER //
// ./src/app/ui/main/Main.js